"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.withRetry = void 0;
/**
 * Retries a function call if it fails, with a specified number of retries.
 *
 * @param fn
 * @param retries
 * @param delayMs
 * @returns
 */
const withRetry = (fn_1, ...args_1) => __awaiter(void 0, [fn_1, ...args_1], void 0, function* (fn, retries = 3, delayMs = 1000) {
    return yield fn().catch((error) => __awaiter(void 0, void 0, void 0, function* () {
        console.warn(`error: ${error}. retries left: ${retries}`);
        if (retries > 0) {
            yield new Promise((resolve) => setTimeout(resolve, delayMs));
            return (0, exports.withRetry)(fn, retries - 1, delayMs);
        }
        else {
            throw error;
        }
    }));
});
exports.withRetry = withRetry;
//# sourceMappingURL=helper.js.map